import { Component, EventEmitter, Input, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { CampaignsService } from '../../services/campaigns.service';
import { LineItemsAutocompleteComponent } from './line-items-autocomplete.component';
import { LineItem } from 'src/app/shared/domain/campaigns.model';

@Component({
  selector: 'ctv-line-items-autocomplete-chips',
  template: `
    <ctv-line-items-autocomplete #pc
                                     (lineItemSelected)="onItemSelected($event)"
                                     [formFieldClass]="formFieldClass"
                                     [formFieldAppearance]="formFieldAppearance"
                                     [required]="required"
                                     [label]="placeholder"
                                     [floatLabel]="floatLabel">
    </ctv-line-items-autocomplete>
    <mat-chip-list #chipList class="mt-n3" [ngClass]="[stacked ? 'mat-chip-list-stacked' : '', items.length > 0 ? 'mb-3' : '']" [hidden]="items.length < 1">
      <mat-basic-chip *ngFor="let item of items"
                      (removed)="remove(item)">
                      {{item.name}}
        <i class="fas fa-times-circle text-danger hand" matChipRemove></i>
      </mat-basic-chip>
    </mat-chip-list>
  `,
})
export class LineItemsAutocompleteChipsComponent implements OnInit {
  @ViewChild(LineItemsAutocompleteComponent, {static: true}) pc: LineItemsAutocompleteComponent;
/** Pass clearFilterItems = new Subject<void>(); as Observable into it and then call clearFilterItems.next() to clear all the items*/
@Input() clearItems: Observable<void>;

@Input()
public placeholder: string;

@Input()
public stacked: false;

@Input()
public lineItemIds: string[];

@Input()
public floatLabel: string;

@Input()
public formFieldClass: string;

@Input()
public formFieldAppearance: string;

@Input()
public required = false;

@Output()
lineItemSelectionChange = new EventEmitter<LineItem[]>();

items: LineItem[] = [];

constructor(private service: CampaignsService) {
}

ngOnInit(): void {
  if (this.lineItemIds && this.lineItemIds.length) {
    //On parent component reload if there is single preselected item, it will actually be passed as string instead of a list
    if (typeof this.lineItemIds === 'string') {
      this.lineItemIds = [this.lineItemIds];
    }
    //Fetch only preselected line items
    this.service.getLineItemsListFiltered({ids: this.lineItemIds}).subscribe(lineItems => {
      lineItems.content.map(ln => {
        this.items.push(ln);
      });
      this.pc.updateFilteredLineItems(this.items);
    });
  }
  this.clearItems?.subscribe(() => this.clearFilter());
}

onItemSelected($event: LineItem) {
  if ($event) {
    this.items.push($event);
    this.lineItemSelectionChange.emit(this.items);
    this.pc.resetInput();
    this.pc.updateFilteredLineItems(this.items);
  }
}

remove(lineItem: LineItem) {
  this.items.splice(this.items.indexOf(lineItem), 1);
  this.lineItemSelectionChange.emit(this.items);
  this.pc.updateFilteredLineItems(this.items);
}

/** Clear all items from filter. */
clearFilter() {
  this.items = [];
  this.pc.updateFilteredLineItems(this.items);
}

disableFilter(disable: boolean) {
  if (disable) {
    this.pc.disable();
  }
  else {
    this.pc.enable();
  }
}
}
